<h3 mat-dialog-title class="title">
    Offer Status
</h3>
<mat-progress-bar *ngIf="isLoading || isSubmitting" mode="indeterminate"></mat-progress-bar>

<mat-dialog-content class="pr-0 pb-0 dialog-body">
    <form [formGroup]="billingUpdateForm">
        <div class="dialog-body flex-row">
            <div class="flex-row flex-100">
                <div class="flex-col flex-100">
                    <nova-am-submittal-send-to-client-info-card [model]="permPostOfferOfferModel" [labelFlex]="labelFlex"
                        [dataFlex]="dataFlex">
                    </nova-am-submittal-send-to-client-info-card>

                    <div class="flex-row block center-datapicker-line">
                        <div class="nova__label flex-25">Billing Amount</div>
                        <mat-form-field data-qa-id="perm_offer_billing_update_modal_billing_amount_form_field">
                            <span matPrefix>$ &nbsp;</span>
                            <input matInput type="number" placeholder="Enter Billing Amount"
                                formControlName="billingAmount" (keypress)="checkChar($event)"
                                (blur)="onBlur($event)" class="post-offer-modal-field">
                            <mat-error class="subtext"
                                *ngIf="billingAmountControl?.invalid">{{billingAmountError}}</mat-error>
                            <mat-hint class="subtext" *ngIf="!billingAmountControl?.invalid">ex:
                                100.00</mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="flex-row block center-datapicker-line">
                        <div class="nova__label flex-25">Final Billing Amount</div>
                        <mat-form-field data-qa-id="perm_offer_billing_update_modal_discount_billing_amount_form_field">
                            <span matPrefix>$ &nbsp;</span>
                            <input matInput type="number" placeholder="Enter Final Billing Amt"
                                formControlName="discountBillingAmount" (keypress)="checkChar($event)"
                                (blur)="onBlur($event)" class="post-offer-modal-field">
                            <mat-error class="subtext"
                                *ngIf="discountBillingAmountControl?.invalid">{{discountBillingAmountError}}</mat-error>
                            <mat-hint class="subtext" *ngIf="!discountBillingAmountControl?.invalid">ex:
                                100.00</mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="flex-row block center-datapicker-line">
                        <div class="nova__label flex-25">Start Date</div>
                        <mat-form-field data-qa-id="perm_offer_billing_update_modal_start_date_form_field">
                            <input matInput placeholder="Select Start Date" [matDatepicker]="startDatePicker"
                                formControlName="startDate" [min]="offerDate"
                                class="post-offer-modal-field">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                            <mat-error class="subtext" *ngIf="startDateControl?.invalid">{{startDateError}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="flex-row pt-0">
                        <div class="nova__label flex-25"></div>
                        <div class="flex-75">
                            <div>
                                <button id="update"  mat-flat-button
                                    [disabled]="billingUpdateForm?.invalid || isLoading || isSubmitting" color="primary"
                                    (click)="onSubmit()" data-qa-id="perm_offer_billing_update_modal_update_button">
                                    UPDATE
                                </button>

                                <button mat-flat-button (click)="closeDialog()" color="cancel"
                                    [disabled]="isSubmitting" data-qa-id="perm_offer_billing_update_modal_cancel_button">
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
